import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";

const trainingData = [
  { name: "VP (증기압)", count: 3132, color: "#8b5cf6" },
  { name: "Solubility (용해도)", count: 8789, color: "#0ea5e9" },
];

const modelComparison = [
  {
    property: "모델명",
    smilesMatcher: "SmilesMatcher",
    krovex: "KROVEX",
  },
  {
    property: "알고리즘",
    smilesMatcher: "JSD 거리 기반 매칭",
    krovex: "GCN + Bilinear Fusion",
  },
  {
    property: "입력",
    smilesMatcher: "m/z 스펙트럼",
    krovex: "SMILES 분자 구조",
  },
  {
    property: "출력",
    smilesMatcher: "화합물 동정 (Top-K)",
    krovex: "VP / Solubility 예측",
  },
  {
    property: "참조 DB",
    smilesMatcher: "142 화합물",
    krovex: "VP 3,132 / Sol 8,789",
  },
  {
    property: "GPU 필요",
    smilesMatcher: "불필요",
    krovex: "선택적 (CPU 가능)",
  },
  {
    property: "의존성",
    smilesMatcher: "numpy, pandas",
    krovex: "torch, dgl, rdkit",
  },
  {
    property: "Fallback",
    smilesMatcher: "랜덤 Mock 매칭",
    krovex: "Mock NFPA 데이터",
  },
];

export default function TrainingDataOverview() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <div className="w-2 h-2 bg-indigo-500 rounded-full" />
        학습 데이터 및 모델 비교
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Training Data Bar Chart */}
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-3">
            학습 데이터 규모
          </h4>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={trainingData} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" tick={{ fontSize: 11 }} />
              <YAxis
                dataKey="name"
                type="category"
                width={120}
                tick={{ fontSize: 12 }}
              />
              <Tooltip
                formatter={(value) => [
                  `${Number(value).toLocaleString()}건`,
                  "데이터 수",
                ]}
              />
              <Bar dataKey="count" radius={[0, 4, 4, 0]} barSize={40}>
                {trainingData.map((entry) => (
                  <Cell key={entry.name} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Model Comparison Table */}
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-3">
            모델 파라미터 비교
          </h4>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-2 px-3 text-gray-600 font-medium">
                    항목
                  </th>
                  <th className="text-left py-2 px-3 text-blue-700 font-medium">
                    SmilesMatcher
                  </th>
                  <th className="text-left py-2 px-3 text-purple-700 font-medium">
                    KROVEX
                  </th>
                </tr>
              </thead>
              <tbody>
                {modelComparison.map((row) => (
                  <tr
                    key={row.property}
                    className="border-b border-gray-100 hover:bg-gray-50"
                  >
                    <td className="py-2 px-3 font-medium text-gray-700">
                      {row.property}
                    </td>
                    <td className="py-2 px-3 text-gray-600">
                      {row.smilesMatcher}
                    </td>
                    <td className="py-2 px-3 text-gray-600">{row.krovex}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
